import type { AskPageContext, CrmRecordType } from "./types/chat.types";

export type AskCrmRecordContext = Extract<AskPageContext, { kind: "crm-record" }>;

type Listener = () => void;

let current: AskCrmRecordContext | null = null;
const listeners = new Set<Listener>();

function notify(): void {
  listeners.forEach((listener) => listener());
}

/** Publish the open CRM detail record for Ask Type anything bar (story 12.5). */
export function setAskCrmRecordContext(ctx: AskCrmRecordContext): void {
  current = ctx;
  notify();
}

/**
 * Clear published CRM context. When `recordId` is passed, only clears if it
 * still matches (avoids races when switching between detail panels).
 */
export function clearAskCrmRecordContext(recordId?: string): void {
  if (
    recordId &&
    current?.kind === "crm-record" &&
    current.recordId !== recordId
  ) {
    return;
  }
  current = null;
  notify();
}

export function getAskCrmRecordContext(): AskCrmRecordContext | null {
  return current;
}

export function subscribeAskCrmRecordContext(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function toAskCrmRecordContext(input: {
  recordId: string;
  recordType: CrmRecordType | string;
  displayName?: string;
  subtitle?: string;
  avatarUrl?: string;
}): AskCrmRecordContext {
  return {
    kind: "crm-record",
    recordId: input.recordId,
    recordType: input.recordType,
    displayName: input.displayName,
    subtitle: input.subtitle,
    avatarUrl: input.avatarUrl,
  };
}
